import React from 'react'
import Heading from './Heading'

export default function Poster () {
  return (
    <>
      <Heading title='Plakát' />
      <p className='lead'>Ještě není hotový</p>
    </>
  )
}
